import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useReportsData } from '../../hooks/useReportsData';
import { Loader2, Gavel, FileSignature, Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { StatusBadge } from '../../components/badges/StatusBadge';

export const ProceduresReport = () => {
    const [searchParams] = useSearchParams();
    const filters = { client: searchParams.get('client') };
    const { procedures, loading } = useReportsData(filters);

    if (loading) return <div className="p-12 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-gray-400" /></div>;

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-900">Procedimientos & Litigios</h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                <div className="lg:col-span-3">
                    <Tabs defaultValue="all" className="w-full">
                        <TabsList className="mb-4">
                            <TabsTrigger value="all">Todos</TabsTrigger>
                            <TabsTrigger value="oposiciones">Oposiciones</TabsTrigger>
                            <TabsTrigger value="renovaciones">Renovaciones</TabsTrigger>
                        </TabsList>

                        <TabsContent value="all" className="space-y-4">
                            {procedures.map(proc => (
                                <Card key={proc.id} className="hover:border-indigo-200 transition-colors">
                                    <CardContent className="p-4 flex flex-col sm:flex-row items-center justify-between gap-4">
                                        <div className="flex items-start gap-3">
                                            <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg">
                                                <Gavel className="h-5 w-5" />
                                            </div>
                                            <div>
                                                <h4 className="font-bold text-gray-900">{proc.type}</h4>
                                                <p className="text-sm text-gray-500">Marca: {proc.trademark} • Cliente: {proc.client}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-end gap-1">
                                            <span className="text-sm font-medium">{proc.status}</span>
                                            <span className="text-xs text-gray-400 flex items-center gap-1">
                                                <Clock className="h-3 w-3" /> Vence: {proc.date}
                                            </span>
                                        </div>
                                    </CardContent>
                                </Card>
                            ))}
                        </TabsContent>
                        <TabsContent value="oposiciones">
                            <p className="text-gray-500 py-8 text-center text-sm">Filtrando Oposiciones (Prototipo - usa pestaña Todos)</p>
                        </TabsContent>
                    </Tabs>
                </div>

                <div className="lg:col-span-1 space-y-4">
                    <Card>
                        <CardHeader className="pb-2"><CardTitle className="text-sm">Próximos Vencimientos</CardTitle></CardHeader>
                        <CardContent>
                            <div className="space-y-4">
                                {procedures.slice(0, 3).map(p => (
                                    <div key={p.id} className="text-sm border-l-2 border-red-500 pl-3">
                                        <p className="font-medium text-gray-900 mb-0.5">{p.date}</p>
                                        <p className="text-gray-500 text-xs">{p.type} - {p.trademark}</p>
                                    </div>
                                ))}
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    );
};
